<app-mat-spinner-overlay *ngIf="showSpinner"> </app-mat-spinner-overlay>
<div class="row m-0 mb-1">
  <div class="col-md-12">
    <div class="custom-tab-switcher d-flex">
      <!-- My Task Tab -->
      <div class="tab-item me-2" [ngClass]="{ active: tab === 'mytask' }" (click)="changeTab('mytask')">
        LOS Tasks
      </div>
      <!-- My Dashboard Tab -->
      <div class="tab-item me-2" [ngClass]="{ active: tab === 'reports' }" (click)="changeTab('reports')">
        LOS Reports
      </div>

      <!-- View By Team Tab -->
      <div class="tab-item me-2" [ngClass]="{ active: tab === 'team' }" (click)="changeTab('team')">
        Team View
      </div>

      <!-- View By Process Tab -->
      <div class="tab-item" [ngClass]="{ active: tab === 'process' }" (click)="changeTab('process')">
        Process View
      </div>
    </div>
  </div>
</div>

<div class="mb-3 reports-tab" *ngIf="tab == 'reports'">
  <div class="text-left my-1 pr-2">
    <div class="row m-0 mt-2 col-md-12 float-end formborder" style="display: flex; align-items: center">
      <div class="col-md-2" style="margin-bottom: 10px">
        <span>From Date </span>
        <div class="datepicker_feild">
          <input [matDatepicker]="picker" dateConvert placeholder="DD/MM/YYYY" name="DateFrom" [(ngModel)]="DateFrom"
            [max]="maxDate" [matDatepickerFilter]="fromDateFilter" id="DateFrom" class="form-control input-text-css"
            #refDateFrom="ngModel" />
          <!-- Prevents selecting future date -->
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </div>
      </div>

      <div class="col-md-2" style="margin-bottom: 10px">
        <span>To Date</span>
        <div class="datepicker_feild">
          <input [matDatepicker]="picker2" dateConvert placeholder="DD/MM/YYYY" name="DateTo" [(ngModel)]="DateTo"
            [max]="maxDate" [matDatepickerFilter]="toDateFilter" id="DateTo" class="form-control input-text-css"
            #refDateTo="ngModel" />
          <!-- Prevents selecting future date -->
          <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
          <mat-datepicker #picker2></mat-datepicker>
        </div>
      </div>
      <div class="mt-3 col-md-1 text-right" style="margin-left: 5px">
        <button type="button" (click)="onSearchReportsSummary()" class="btn font-size-12 button-btn"
          style="float: left">
          Search
        </button>
      </div>
    </div>
    <div class="row m-0" style="margin-top: 20px">
      <div class="col-lg-3 col-md-4 col-sm-6 p-2" *ngFor="let item of dashboardReportData">
        <div class="dashboard-card shadow-sm" (click)="goToPageReports(item)">
          <div class="card-header text-center">
            <b>{{ item.ReportName }}</b>
          </div>

          <div class="card-body">
            <div class="row text-center" style="
                display: flex;
                justify-content: center;
                align-items: center;
                text-align: center;
              ">
              <div class="col-6">
                <span class="label"></span>
                <div class="custom-badge-pending" style="
                    background: #e6f7f7;
                    border-radius: 18px;
                    padding: 8px 18px;
                    min-width: 38px;
                    min-height: 38px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  ">
                  <span style="
                      font-size: 1.5rem;
                      font-weight: 700;
                      color: #218d86;
                      line-height: 1;
                    ">{{ item.ReportRowCount }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="mb-3" *ngIf="tab == 'mytask'">
  <div class="text-right my-1 pr-2">
    <button class="mt-2 btn font-size-12 button-btn" style="width: max-content" *ngIf="AddLoan">
      <a class="text-underling-cursor" href="javascript:void(0)" (click)="onOpenNewInquiryModel()" style="
          text-decoration: none !important;
          color: #fff !important;
          font-size: 14px;
        ">
        Register A New Enquiry
      </a>
    </button>
  </div>
  <div class="row m-0">
    <div class="col-lg-3 col-md-4 col-sm-6 p-2" *ngFor="let item of dashboardData">
      <div class="dashboard-card shadow-sm" (click)="goToPage(item)">
        <div class="card-header text-center">
          <b>{{ item.EmpProcessName }}</b>
        </div>

        <div class="card-body">
          <div class="row text-center">
            <div class="col-6">
              <span class="label">Pending</span>
              <div class="custom-badge-pending">
                <span style="font-size: 1.5rem">{{ item.ItemCount }}</span>
              </div>
              <div class="amount-small">
                <ng-container *ngIf="item.Amount > 0; else emptyAmount">
                  ₹{{ item.Amount | number : "1.0-2" }}
                </ng-container>
                <ng-template #emptyAmount>&nbsp;</ng-template>
              </div>
            </div>
            <div class="col-6">
              <span class="label">Reverted</span>
              <div class="custom-badge-reverted">
                <span style="font-size: 1.5rem">{{ item.RevertCount }}</span>
              </div>
              <div class="amount-small">
                <ng-container *ngIf="item.RevertAmount > 0; else emptyRevert">
                  ₹{{ item.RevertAmount | number : "1.0-2" }}
                </ng-container>
                <ng-template #emptyRevert>&nbsp;</ng-template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="row m-0 col-md-12 p-1" *ngIf="tab == 'process'">
  <div class="row m-0 col-md-12 p-0 mb-4">
    <div class="col-md-12 p-2 box mt-2" *ngFor="let item of processListData; let ind = index">
      <!-- <div class="d-flex align-items-center pl-4 pr-4 justify-content-between box-content"
             style="width: 80%;">
          <span> {{item.Process_Name}} </span>
          <span> {{item.ApplicationCount}} </span>
        </div> -->
      <div class="card d-flex flex-row justify-content-between align-items-center" style="
          height: max-content;
          padding: 0px 20px;
          background: linear-gradient(
            135deg,
            rgb(33, 141, 134),
            rgb(239 255 254)
          );
        " [ngClass]="{ dataactive: selectedProcess?.ProcessId == item.ProcessId }" (click)="getDetail(item)">
        <div style="color: #fff; display: flex; justify-content: space-between" class="font-weight-bolder">
          <span style="font-size: 20px"> {{ item.Process_Name }} </span>
        </div>
        <div class="d-flex justify-content-between align-items-center" style="height: 52px; width: 100px">
          <span class="badge-darker" style="
              font-size: 18px;
              padding: 3px 12px;
              max-width: auto;
              min-width: 60px;
              border-radius: 10px;
            ">
            {{ item.ApplicationCount }}
          </span>
          <i class="fa" [ngClass]="
              selectedProcess?.ProcessId == item.ProcessId
                ? 'fa-chevron-up'
                : 'fa-chevron-down'
            " style="cursor: pointer; font-size: x-large" (click)="getDetail(item)"></i>
        </div>
      </div>
      <div class="table-wrapper" [class.expanded]="selectedTeam?.EmpId == item.EmpId">
        <div class="table-responsive" style="border-radius: 0px 0px 12px 12px; border: 2px solid #5e96b5"
          *ngIf="selectedProcess?.ProcessId == item.ProcessId">
          <div class="row m-0 mt-2 col-md-12 float-end" style="
              display: flex;
              align-items: center;
              justify-content: space-between;
            ">
            <div class="col-md-2" style="margin-bottom: 10px">
              <span>Status</span>
              <!--  -->
              <select name="Status" id="Status" #refStatus="ngModel" class="form-control input-text-css"
                [(ngModel)]="Status">
                <option value="Pending">Pending/Reverted</option>
                <option value="Reject">Rejected</option>
                <option value="Completed">Completed</option>
              </select>
            </div>
            <div class="col-md-2" style="margin-bottom: 10px">
              <span>From Date</span>
              <div class="datepicker_feild">
                <input [matDatepicker]="picker" dateConvert placeholder="DD/MM/YYYY" name="DateFrom"
                  [(ngModel)]="DateFrom" [max]="maxDate" [matDatepickerFilter]="fromDateFilter" id="DateFrom"
                  class="form-control input-text-css" #refDateFrom="ngModel" />
                <!-- Prevents selecting future date -->
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </div>
            </div>

            <div class="col-md-2" style="margin-bottom: 10px">
              <span>To Date</span>
              <div class="datepicker_feild">
                <input [matDatepicker]="picker2" dateConvert placeholder="DD/MM/YYYY" name="DateTo" [(ngModel)]="DateTo"
                  [max]="maxDate" [matDatepickerFilter]="toDateFilter" id="DateTo" class="form-control input-text-css"
                  #refDateTo="ngModel" />
                <!-- Prevents selecting future date -->
                <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                <mat-datepicker #picker2></mat-datepicker>
              </div>
            </div>

            <div class="col-md-2" style="margin-bottom: 10px">
              <span>Branch</span>
              <select name="BranchId" id="BranchId" [(ngModel)]="BranchId" class="form-control input-text-css">
                <option value="0">Branch</option>
                <option *ngFor="let item of BranchesList" [value]="item.BranchId">
                  {{ item.Branch_Name }}
                </option>
              </select>
            </div>

            <div class="col-md-2 p-1 mt-2 text-right" style="margin-bottom: 10px">
              <form action="" class="search-text">
                <div class="bg-light rounded rounded-pill shadow-sm">
                  <div class="input-group">
                    <input type="text" id="FilterInputSearch" (keyup)="applyFilter($event.target.value)"
                      name="FilterInputSearch" placeholder="Searching for?" class="form-control border-0 bg-light" />
                    <div class="input-group-append">
                      <button id="button-addon1" type="submit" class="btn btn-link text-primary">
                        <i class="fa fa-search"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div class="mt-3 col-md-1 text-right" style="margin-left: 5px">
              <button type="button" (click)="onChangeStatusofProcess()" class="btn font-size-12 button-btn"
                style="float: right">
                Search
              </button>
            </div>
          </div>
          <mat-table [dataSource]="dataProcessSource" matSort>
            <!-- ApplicationId -->
            <ng-container matColumnDef="ApplicationId">
              <mat-header-cell mat-sort-header class="grid-header" style="max-width: 50px" *matHeaderCellDef>
                #
              </mat-header-cell>
              <mat-cell *matCellDef="let row; let i = index" class="grid-cell" style="max-width: 50px">
                {{ paginatorRef.pageIndex * paginatorRef.pageSize + (i + 1) }}
              </mat-cell>
              <mat-footer-cell *matFooterCellDef></mat-footer-cell>
            </ng-container>

            <!-- Application_No -->
            <ng-container matColumnDef="Application_No">
              <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>
                Application No
              </mat-header-cell>
              <mat-cell *matCellDef="let row; let i = index" class="grid-cell">
                <app-main-card-info [loanId]="row.ApplicationIdentity" [index]="i">
                  {{ row.Application_No }}
                </app-main-card-info>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef></mat-footer-cell>
            </ng-container>

            <!-- Customer -->
            <ng-container matColumnDef="Customer">
              <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>Customer</mat-header-cell>
              <mat-cell *matCellDef="let row" class="grid-cell">{{
                row.Customer
                }}</mat-cell>
              <mat-footer-cell *matFooterCellDef>Total: </mat-footer-cell>
            </ng-container>

            <!-- Product_Name -->
            <ng-container matColumnDef="Product_Name">
              <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>Product Name</mat-header-cell>
              <mat-cell *matCellDef="let row" class="grid-cell">{{
                row.Product_Name
                }}</mat-cell>
              <mat-footer-cell *matFooterCellDef></mat-footer-cell>
            </ng-container>

            <!-- Application_LoanAmount -->
            <ng-container matColumnDef="Application_LoanAmount">
              <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>Loan Amount</mat-header-cell>
              <mat-cell *matCellDef="let row" class="grid-cell">
                {{ row.Application_LoanAmount | number : "1.0-2" }}
              </mat-cell>
              <mat-footer-cell *matFooterCellDef style="font-weight: bold; text-align: right">
                {{ getTotalLoanAmount() | number : "1.0-2" }}
              </mat-footer-cell>
            </ng-container>

            <!-- Branch_Name -->
            <ng-container matColumnDef="Branch_Name">
              <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>Branch Name</mat-header-cell>
              <mat-cell *matCellDef="let row" class="grid-cell">{{
                row.Branch_Name
                }}</mat-cell>
              <mat-footer-cell *matFooterCellDef></mat-footer-cell>
            </ng-container>

            <!-- SourceType -->
            <ng-container matColumnDef="SourceType">
              <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>Source Type</mat-header-cell>
              <mat-cell *matCellDef="let row" class="grid-cell">{{
                row.SourceType
                }}</mat-cell>
              <mat-footer-cell *matFooterCellDef></mat-footer-cell>
            </ng-container>

            <!-- SourceName -->
            <ng-container matColumnDef="SourceName">
              <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>Source Name</mat-header-cell>
              <mat-cell *matCellDef="let row" class="grid-cell">{{
                row.SourceName
                }}</mat-cell>
              <mat-footer-cell *matFooterCellDef></mat-footer-cell>
            </ng-container>

            <!-- EmpName -->
            <ng-container matColumnDef="EmpName">
              <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>Employee</mat-header-cell>
              <mat-cell *matCellDef="let row" class="grid-cell">{{
                row.EmpName
                }}</mat-cell>
              <mat-footer-cell *matFooterCellDef></mat-footer-cell>
            </ng-container>

            <!-- AssignOn -->
            <ng-container matColumnDef="AssignOn">
              <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>Assign On</mat-header-cell>
              <mat-cell *matCellDef="let row" class="grid-cell">{{
                row.AssignOn
                }}</mat-cell>
              <mat-footer-cell *matFooterCellDef></mat-footer-cell>
            </ng-container>

            <!-- AP_ProcessStatus -->
            <ng-container matColumnDef="AP_ProcessStatus">
              <mat-header-cell mat-sort-header class="grid-header" style="max-width: 150px"
                *matHeaderCellDef>Status</mat-header-cell>
              <mat-cell *matCellDef="let row" class="grid-cell" style="max-width: 150px">
                {{ row.AP_ProcessStatus }}
              </mat-cell>
              <mat-footer-cell *matFooterCellDef></mat-footer-cell>
            </ng-container>

            <!-- TAT_Hr -->
            <ng-container matColumnDef="TAT_Hr">
              <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>TAT(Hr)</mat-header-cell>
              <mat-cell *matCellDef="let row" class="grid-cell">{{
                row.TAT_Hr
                }}</mat-cell>
              <mat-footer-cell *matFooterCellDef></mat-footer-cell>
            </ng-container>

            <!-- Action -->
            <ng-container matColumnDef="Action">
              <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>Action</mat-header-cell>
              <mat-cell *matCellDef="let row; let i = index" class="grid-cell">
                <app-main-card-info [loanId]="row.ApplicationIdentity" [index]="i">
                  <i class="fa fa-arrow-circle-right action-btn"> </i>
                </app-main-card-info>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef></mat-footer-cell>
            </ng-container>

            <!-- InquiryId -->
            <ng-container matColumnDef="InquiryId">
              <mat-header-cell mat-sort-header class="grid-header" style="max-width: 50px"
                *matHeaderCellDef>#</mat-header-cell>
              <mat-cell *matCellDef="let row; let i = index" class="grid-cell" style="max-width: 50px">
                {{ paginatorRef.pageIndex * paginatorRef.pageSize + (i + 1) }}
              </mat-cell>
              <mat-footer-cell *matFooterCellDef></mat-footer-cell>
            </ng-container>

            <!-- InquiryNo -->
            <ng-container matColumnDef="InquiryNo">
              <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>Inquiry No</mat-header-cell>
              <mat-cell *matCellDef="let row" class="grid-cell">{{
                row.InquiryNo
                }}</mat-cell>
              <mat-footer-cell *matFooterCellDef></mat-footer-cell>
            </ng-container>

            <!-- CustomerName -->
            <ng-container matColumnDef="CustomerName">
              <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>Customer Name</mat-header-cell>
              <mat-cell *matCellDef="let row" class="grid-cell">{{
                row.CustomerName
                }}</mat-cell>
              <mat-footer-cell *matFooterCellDef>Total: </mat-footer-cell>
            </ng-container>

            <!-- CustomerAddress -->
            <ng-container matColumnDef="CustomerAddress">
              <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>Customer Address</mat-header-cell>
              <mat-cell *matCellDef="let row" class="grid-cell">{{
                row.CustomerAddress
                }}</mat-cell>
              <mat-footer-cell *matFooterCellDef></mat-footer-cell>
            </ng-container>

            <!-- ContactNumber -->
            <ng-container matColumnDef="ContactNumber">
              <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>Contact Number</mat-header-cell>
              <mat-cell *matCellDef="let row" class="grid-cell">{{
                row.ContactNumber
                }}</mat-cell>
              <mat-footer-cell *matFooterCellDef></mat-footer-cell>
            </ng-container>

            <!-- Source -->
            <ng-container matColumnDef="Source">
              <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>Source</mat-header-cell>
              <mat-cell *matCellDef="let row" class="grid-cell">{{
                row.Source
                }}</mat-cell>
              <mat-footer-cell *matFooterCellDef></mat-footer-cell>
            </ng-container>

            <!-- Purpose -->
            <ng-container matColumnDef="Purpose">
              <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>Purpose</mat-header-cell>
              <mat-cell *matCellDef="let row" class="grid-cell">{{
                row.Purpose
                }}</mat-cell>
              <mat-footer-cell *matFooterCellDef></mat-footer-cell>
            </ng-container>

            <!-- LoanAmount -->
            <ng-container matColumnDef="LoanAmount">
              <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>Loan Amount</mat-header-cell>
              <mat-cell *matCellDef="let row" class="grid-cell">{{
                row.LoanAmount
                }}</mat-cell>
              <mat-footer-cell *matFooterCellDef>
                <strong>{{ getTotalLoanAmount() }}</strong>
              </mat-footer-cell>
            </ng-container>

            <!-- Status -->
            <ng-container matColumnDef="Status">
              <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>Status</mat-header-cell>
              <mat-cell *matCellDef="let row" class="grid-cell">{{
                row.Status
                }}</mat-cell>
              <mat-footer-cell *matFooterCellDef></mat-footer-cell>
            </ng-container>

            <!-- CreateOn -->
            <ng-container matColumnDef="CreateOn">
              <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>Create On</mat-header-cell>
              <mat-cell *matCellDef="let row" class="grid-cell">{{
                row.CreateOn
                }}</mat-cell>
              <mat-footer-cell *matFooterCellDef></mat-footer-cell>
            </ng-container>

            <!-- CreatedBy -->
            <ng-container matColumnDef="CreatedBy">
              <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>Created By</mat-header-cell>
              <mat-cell *matCellDef="let row" class="grid-cell">{{
                row.CreatedBy
                }}</mat-cell>
              <mat-footer-cell *matFooterCellDef></mat-footer-cell>
            </ng-container>

            <!-- SaleExcutive -->
            <ng-container matColumnDef="SaleExcutive">
              <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>Sale Excutive</mat-header-cell>
              <mat-cell *matCellDef="let row" class="grid-cell">{{
                row.SaleExcutive
                }}</mat-cell>
              <mat-footer-cell *matFooterCellDef></mat-footer-cell>
            </ng-container>

            <!-- Branch -->
            <ng-container matColumnDef="Branch">
              <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>Branch</mat-header-cell>
              <mat-cell *matCellDef="let row" class="grid-cell">{{
                row.Branch
                }}</mat-cell>
              <mat-footer-cell *matFooterCellDef></mat-footer-cell>
            </ng-container>

            <!-- Rows -->
            <mat-header-row *matHeaderRowDef="displayedProcessColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedProcessColumns"></mat-row>
            <mat-footer-row *matFooterRowDef="displayedProcessColumns"></mat-footer-row>
          </mat-table>

          <div class="col-md-12 row">
            <div class="col-md-4">
              <button class="mt-2 btn font-size-12 button-btn" (click)="exportexcelByProcess(item.Process_Name)">
                <i class="fa fa-file-export mr-1" style="font-size: medium; cursor: pointer"></i>
                Export
              </button>
            </div>
            <div class="col-md-8">
              <mat-paginator #paginatorRef [pageSizeOptions]="[20, 50]" showFirstLastButtons>
              </mat-paginator>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="row m-0 col-md-12 p-1" *ngIf="tab == 'team'">
  <div class="row m-0 col-md-12 p-0 mb-4">
    <div class="col-md-12 p-2 box" *ngFor="let item of teamListData; let ind = index">
      <div class="card d-flex flex-row justify-content-between align-items-center" style="
          height: fit-content;
          padding: 0px 20px;
          background: linear-gradient(
            135deg,
            rgb(33, 141, 134),
            rgb(239 255 254)
          );
        " [ngClass]="{ dataactive: selectedTeam?.EmpId == item.EmpId }" (click)="getTeamDetail(item)">
        <div style="color: #fff; display: flex; justify-content: space-between" class="font-weight-bolder">
          <span style="font-size: 20px">{{ item.EmpName }}</span>
        </div>
        <div class="d-flex justify-content-between align-items-center" style="height: 52px; width: 100px">
          <span class="badge-darker" style="
              font-size: 18px;
              padding: 3px 12px;
              max-width: auto;
              min-width: 60px;
              border-radius: 10px;
            ">
            {{ item.ApplicationCount }}
          </span>
          <!-- 📌 Accordion Icon -->
          <i class="fa" [ngClass]="
              selectedTeam?.EmpId == item.EmpId
                ? 'fa-chevron-up'
                : 'fa-chevron-down'
            " style="cursor: pointer; font-size: x-large" (click)="getTeamDetail(item)"></i>
        </div>
      </div>

      <!-- ✅ Show table only when this card is selected -->
      <div class="table-wrapper" [class.expanded]="selectedTeam?.EmpId == item.EmpId">
        <div style="border-radius: 0px 0px 12px 12px; border: 2px solid #5e96b5"
          *ngIf="selectedTeam?.EmpId == item.EmpId" class="table-responsive">
          <!--  -->

          <!-- 🔍 Search Bar -->
          <div class="row m-2 col-md-12 float-end">
            <div class="col-md-2">
              <span>From Date</span>
              <div class="datepicker_feild">
                <input [matDatepicker]="picker" dateConvert placeholder="DD/MM/YYYY" name="DateFrom"
                  [(ngModel)]="DateFrom" [max]="maxDate" [matDatepickerFilter]="fromDateFilter" id="DateFrom"
                  class="form-control input-text-css" #refDateFrom="ngModel" />
                <!-- Prevents selecting future date -->
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </div>
            </div>

            <div class="col-md-2">
              <span>To Date</span>
              <div class="datepicker_feild">
                <input [matDatepicker]="picker2" dateConvert placeholder="DD/MM/YYYY" name="DateTo" [(ngModel)]="DateTo"
                  [max]="maxDate" [matDatepickerFilter]="toDateFilter" id="DateTo" class="form-control input-text-css"
                  #refDateTo="ngModel" />
                <!-- Prevents selecting future date -->
                <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                <mat-datepicker #picker2></mat-datepicker>
              </div>
            </div>

            <div class="col-md-3">
              <span>Select Branch</span>
              <select name="BranchId" id="BranchId" [(ngModel)]="BranchId" class="form-control input-text-css">
                <option value="0">Select Branch</option>
                <option *ngFor="let item of BranchesList" [value]="item.BranchId">
                  {{ item.Branch_Name }}
                </option>
              </select>
            </div>
            <div class="col-md-3 p-1 mt-2">
              <form class="search-text">
                <div class="bg-light rounded rounded-pill shadow-sm">
                  <div class="input-group">
                    <input type="text" (keyup)="applyFilter($event.target.value)"
                      placeholder="What're you searching for?" class="form-control border-0 bg-light" />
                    <div class="input-group-append">
                      <button type="submit" class="btn btn-link text-primary">
                        <i class="fa fa-search"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>

            <div class="mt-3 col-md-2 text-right">
              <button type="button" (click)="onChangeTeamDetail()" class="btn font-size-12 button-btn"
                style="float: right">
                Search
              </button>
            </div>
          </div>

          <!-- 🧾 Table -->
          <mat-table [dataSource]="dataTeamSource" matSort class="mt-3">
            <!-- Index Column -->
            <ng-container matColumnDef="ApplicationId">
              <mat-header-cell mat-sort-header *matHeaderCellDef style="max-width: 50px">#</mat-header-cell>
              <mat-cell *matCellDef="let row; let i = index" style="max-width: 50px">
                {{
                tpaginatorRef?.pageIndex * tpaginatorRef?.pageSize + (i + 1)
                }}
              </mat-cell>
              <mat-footer-cell *matFooterCellDef></mat-footer-cell>
            </ng-container>

            <!-- Application No -->
            <ng-container matColumnDef="Application_No">
              <mat-header-cell mat-sort-header *matHeaderCellDef>Application No</mat-header-cell>
              <mat-cell *matCellDef="let row; let i = index">
                <app-main-card-info [loanId]="row.ApplicationIdentity" [index]="i">
                  {{ row.Application_No }}
                </app-main-card-info>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef></mat-footer-cell>
            </ng-container>

            <!-- Customer -->
            <ng-container matColumnDef="Customer">
              <mat-header-cell mat-sort-header *matHeaderCellDef>Customer</mat-header-cell>
              <mat-cell *matCellDef="let row">{{ row.Customer }}</mat-cell>
              <mat-footer-cell *matFooterCellDef>Total: </mat-footer-cell>
            </ng-container>

            <!-- Product_Name -->
            <ng-container matColumnDef="Product_Name">
              <mat-header-cell mat-sort-header *matHeaderCellDef>Product Name</mat-header-cell>
              <mat-cell *matCellDef="let row">{{ row.Product_Name }}</mat-cell>
              <mat-footer-cell *matFooterCellDef></mat-footer-cell>
            </ng-container>

            <!-- Loan Amount -->
            <ng-container matColumnDef="Application_LoanAmount">
              <mat-header-cell mat-sort-header *matHeaderCellDef>Loan Amount</mat-header-cell>
              <mat-cell *matCellDef="let row">{{
                row.Application_LoanAmount
                }}</mat-cell>
              <mat-footer-cell *matFooterCellDef>
                <strong style="text-align: start">{{
                  getTotalAmount()
                  }}</strong>
              </mat-footer-cell>
            </ng-container>

            <!-- Branch_Name -->
            <ng-container matColumnDef="Branch_Name">
              <mat-header-cell mat-sort-header *matHeaderCellDef>Branch Name</mat-header-cell>
              <mat-cell *matCellDef="let row">{{ row.Branch_Name }}</mat-cell>
              <mat-footer-cell *matFooterCellDef></mat-footer-cell>
            </ng-container>

            <!-- SourceType -->
            <ng-container matColumnDef="SourceType">
              <mat-header-cell mat-sort-header *matHeaderCellDef>Source Type</mat-header-cell>
              <mat-cell *matCellDef="let row">{{ row.SourceType }}</mat-cell>
              <mat-footer-cell *matFooterCellDef></mat-footer-cell>
            </ng-container>

            <!-- SourceName -->
            <ng-container matColumnDef="SourceName">
              <mat-header-cell mat-sort-header *matHeaderCellDef>Source Name</mat-header-cell>
              <mat-cell *matCellDef="let row">{{ row.SourceName }}</mat-cell>
              <mat-footer-cell *matFooterCellDef></mat-footer-cell>
            </ng-container>

            <!-- Process_Name -->
            <ng-container matColumnDef="Process_Name">
              <mat-header-cell mat-sort-header *matHeaderCellDef>Process Name</mat-header-cell>
              <mat-cell *matCellDef="let row">{{ row.Process_Name }}</mat-cell>
              <mat-footer-cell *matFooterCellDef></mat-footer-cell>
            </ng-container>

            <!-- AssignOn -->
            <ng-container matColumnDef="AssignOn">
              <mat-header-cell mat-sort-header *matHeaderCellDef>Assign On</mat-header-cell>
              <mat-cell *matCellDef="let row">{{ row.AssignOn }}</mat-cell>
              <mat-footer-cell *matFooterCellDef></mat-footer-cell>
            </ng-container>

            <!-- AP_ProcessStatus -->
            <ng-container matColumnDef="AP_ProcessStatus">
              <mat-header-cell mat-sort-header *matHeaderCellDef>Status</mat-header-cell>
              <mat-cell *matCellDef="let row">{{
                row.AP_ProcessStatus
                }}</mat-cell>
              <mat-footer-cell *matFooterCellDef></mat-footer-cell>
            </ng-container>

            <!-- TAT_Hr -->
            <ng-container matColumnDef="TAT_Hr">
              <mat-header-cell mat-sort-header *matHeaderCellDef>TAT(Hr)</mat-header-cell>
              <mat-cell *matCellDef="let row">{{ row.TAT_Hr }}</mat-cell>
              <mat-footer-cell *matFooterCellDef></mat-footer-cell>
            </ng-container>

            <!-- Action -->
            <ng-container matColumnDef="Action">
              <mat-header-cell mat-sort-header *matHeaderCellDef>Action</mat-header-cell>
              <mat-cell *matCellDef="let row; let i = index">
                <app-main-card-info [loanId]="row.ApplicationIdentity" [index]="i">
                  <i class="fa fa-arrow-circle-right action-btn"> </i>
                </app-main-card-info>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef></mat-footer-cell>
            </ng-container>

            <!-- Header Row -->
            <mat-header-row *matHeaderRowDef="displayedTeamColumns"></mat-header-row>

            <!-- Data Row -->
            <mat-row *matRowDef="let row; columns: displayedTeamColumns"></mat-row>

            <!-- Footer Row -->
            <mat-footer-row *matFooterRowDef="displayedTeamColumns"></mat-footer-row>
          </mat-table>

          <!-- 📤 Export & Pagination -->
          <div class="col-md-12 row mt-2">
            <div class="col-md-4">
              <button class="btn btn-sm button-btn" (click)="exportexcelByTeam()">
                <i class="fa fa-file-export mr-1"></i> Export
              </button>
            </div>
            <div class="col-md-8">
              <mat-paginator #tpaginatorRef [pageSizeOptions]="[20, 50]" showFirstLastButtons></mat-paginator>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade in" id="addNewInquiry" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
  data-backdrop="false" style="background-color: rgba(0, 0, 0, 0.5); overflow: auto">
  <form #f="ngForm" (ngSubmit)="onSaveInquiry()" novalidate>
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="modal-content">
        <div cdkDragHandle class="modal-header" style="padding: 10px">
          <h6 class="modal-title" id="myModalLabel" name="myModalLabel">
            Register a new Enquiry
          </h6>
          <button type="button" (click)="OnClose()" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">
              <i class="far text-black fa-times-circle"></i>
            </span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row m-0 formborder">
            <div class="col-md-12 p-1">
              <span class="required-lable"> Lead Source </span>
              <select name="Source" id="Source" #refSource="ngModel" [ngClass]="{
                  'is-invalid': f.submitted && refSource.invalid,
                  'alert-warning':
                    refSource.invalid &&
                    (refSource.dirty ||
                      refSource.touched ||
                      refSource.untouched)
                }" [(ngModel)]="inquiryModel.Source" class="form-control input-text-css" required
                (change)="onChangeSource()">
                <option value="">Select Lead Source</option>
                <option *ngFor="let lead of leadSourceDropdown" [value]="lead.Lead_Source">
                  {{ lead.Lead_Source_DisplayName }}
                </option>
              </select>
            </div>
            <div class="col-md-12 p-1" *ngIf="
                inquiryModel.Source == 'Agent' ||
                inquiryModel.Source == 'DSA' ||
                inquiryModel.Source == 'Dealer' ||
                inquiryModel.Source == 'Reference'
              ">
              <span class="required-lable"> Lead Reference </span>
              <select name="LeadReference" id="LeadReference" #refLeadReference="ngModel"
                *ngIf="inquiryModel.Source != 'Reference'" [ngClass]="{
                  'is-invalid': f.submitted && refLeadReference.invalid,
                  'alert-warning':
                    refLeadReference.invalid &&
                    (refLeadReference.dirty ||
                      refLeadReference.touched ||
                      refLeadReference.untouched)
                }" [(ngModel)]="inquiryModel.LeadReference" class="form-control input-text-css" required>
                <option value="">Select Lead Reference</option>
                <option *ngFor="let partner of partnerDropdown" [value]="partner.PartnerId">
                  {{ partner.Partner_Name }}
                </option>
              </select>
              <input required type="text" #refLeadReference="ngModel" *ngIf="inquiryModel.Source == 'Reference'"
                [ngClass]="{
                  'is-invalid': f.submitted && refLeadReference.invalid,
                  'alert-warning':
                    refLeadReference.invalid &&
                    (refLeadReference.dirty ||
                      refLeadReference.touched ||
                      refLeadReference.untouched)
                }" [(ngModel)]="inquiryModel.LeadReference" placeholder="Lead Reference" name="LeadReference"
                id="LeadReference" class="form-control input-text-css" />
            </div>
            <div class="col-md-6 p-1">
              <span class="required-lable"> Customer </span>
              <input required type="text" #refCustomerName="ngModel" [ngClass]="{
                  'is-invalid': f.submitted && refCustomerName.invalid,
                  'alert-warning':
                    refCustomerName.invalid &&
                    (refCustomerName.dirty ||
                      refCustomerName.touched ||
                      refCustomerName.untouched)
                }" [(ngModel)]="inquiryModel.CustomerName" placeholder="Customer Name" name="CustomerName"
                id="CustomerName" class="form-control input-text-css" />
            </div>
            <div class="col-md-6 p-1">
              <span> Customer Email </span>
              <input type="email" #refCustomerEmail="ngModel" [(ngModel)]="inquiryModel.CustomerEmail"
                placeholder="Customer Email" name="CustomerEmail" id="CustomerEmail" class="form-control input-text-css"
                pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$" [ngClass]="{
                  'is-invalid': f.submitted && refCustomerEmail.invalid,
                  'alert-warning':
                    refCustomerEmail.invalid &&
                    (refCustomerEmail.dirty ||
                      refCustomerEmail.touched ||
                      refCustomerEmail.untouched)
                }" />
            </div>
            <div class="col-md-12 p-1">
              <span class="required-lable"> Customer Address </span>
              <textarea required rows="3" #refCustomerAddress="ngModel" [ngClass]="{
                  'is-invalid': f.submitted && refCustomerAddress.invalid,
                  'alert-warning':
                    refCustomerAddress.invalid &&
                    (refCustomerAddress.dirty ||
                      refCustomerAddress.touched ||
                      refCustomerAddress.untouched)
                }" [(ngModel)]="inquiryModel.CustomerAddress" placeholder="Customer Address" name="CustomerAddress"
                id="CustomerAddress" class="form-control input-text-css"></textarea>
            </div>
            <div class="col-md-6 p-1">
              <span class="required-lable"> State </span>
              <select name="CustomerState" id="CustomerState" #refCustomerState="ngModel" [ngClass]="{
                  'is-invalid': f.submitted && refCustomerState.invalid,
                  'alert-warning':
                    refCustomerState.invalid &&
                    (refCustomerState.dirty ||
                      refCustomerState.touched ||
                      refCustomerState.untouched)
                }" [(ngModel)]="inquiryModel.CustomerState" class="form-control input-text-css" required
                (change)="GetDistrickDropdown()">
                <option value="">Select State</option>
                <option *ngFor="let state of stateDropdown" [value]="state.State_Name">
                  {{ state.State_Name }}
                </option>
              </select>
            </div>
            <div class="col-md-6 p-1">
              <span class="required-lable"> District </span>
              <select name="CustomerDistrict" id="CustomerDistrict" #refCustomerDistrict="ngModel" [ngClass]="{
                  'is-invalid': f.submitted && refCustomerDistrict.invalid,
                  'alert-warning':
                    refCustomerDistrict.invalid &&
                    (refCustomerDistrict.dirty ||
                      refCustomerDistrict.touched ||
                      refCustomerDistrict.untouched)
                }" [(ngModel)]="inquiryModel.CustomerDistrict" class="form-control input-text-css" required
                (change)="GetTehasilDropdown()">
                <option value="">Select District</option>
                <option *ngFor="let district of districkDropdown" [value]="district.District_Name">
                  {{ district.District_Name }}
                </option>
              </select>
            </div>
            <div class="col-md-6 p-1">
              <span class="required-lable"> Tehsil </span>
              <select name="CustomerTehsil" id="CustomerTehsil" #refCustomerTehsil="ngModel" [ngClass]="{
                  'is-invalid': f.submitted && refCustomerTehsil.invalid,
                  'alert-warning':
                    refCustomerTehsil.invalid &&
                    (refCustomerTehsil.dirty ||
                      refCustomerTehsil.touched ||
                      refCustomerTehsil.untouched)
                }" [(ngModel)]="inquiryModel.CustomerTehsil" class="form-control input-text-css" required>
                <option value="">Select Tehsil</option>
                <option *ngFor="let tehsil of tehasilDropdown" [value]="tehsil.Tehsil_Name">
                  {{ tehsil.Tehsil_Name }}
                </option>
              </select>
            </div>
            <div class="col-md-6 p-1">
              <span class="required-lable"> Pincode </span>
              <input required type="text" maxlength="6" minlength="6" numbersOnly #refCustomerPincode="ngModel"
                [ngClass]="{
                  'is-invalid': f.submitted && refCustomerPincode.invalid,
                  'alert-warning':
                    refCustomerPincode.invalid &&
                    (refCustomerPincode.dirty ||
                      refCustomerPincode.touched ||
                      refCustomerPincode.untouched)
                }" [(ngModel)]="inquiryModel.CustomerPincode" placeholder="Customer Pincode" name="CustomerPincode"
                id="CustomerPincode" class="form-control input-text-css" />
            </div>
            <div class="col-md-6 p-1">
              <span class="required-lable"> Contact No </span>
              <input required maxlength="10" minlength="10" numbersOnly type="text" #refContactNumber="ngModel"
                [ngClass]="{
                  'is-invalid': f.submitted && refContactNumber.invalid,
                  'alert-warning':
                    refContactNumber.invalid &&
                    (refContactNumber.dirty ||
                      refContactNumber.touched ||
                      refContactNumber.untouched)
                }" [(ngModel)]="inquiryModel.ContactNumber" placeholder="Contact No" name="ContactNumber"
                id="ContactNumber" class="form-control input-text-css" />
            </div>
            <div class="col-md-6 p-1">
              <span class="required-lable">Required Loan Amount </span>
              <input required type="text" numbersOnly #refLoanAmount="ngModel" [ngClass]="{
                  'is-invalid': f.submitted && refLoanAmount.invalid,
                  'alert-warning':
                    refLoanAmount.invalid &&
                    (refLoanAmount.dirty ||
                      refLoanAmount.touched ||
                      refLoanAmount.untouched)
                }" [(ngModel)]="inquiryModel.LoanAmount" placeholder="Loan Amount" name="LoanAmount" id="LoanAmount"
                class="form-control input-text-css" />
            </div>
            <div class="col-md-12 p-1">
              <span class="required-lable"> Purpose </span>
              <textarea required rows="2" maxlength="150" #refPurpose="ngModel" [ngClass]="{
                  'is-invalid': f.submitted && refPurpose.invalid,
                  'alert-warning':
                    refPurpose.invalid &&
                    (refPurpose.dirty ||
                      refPurpose.touched ||
                      refPurpose.untouched)
                }" [(ngModel)]="inquiryModel.Purpose" placeholder="Purpose" name="Purpose" id="Purpose"
                class="form-control input-text-css"></textarea>
            </div>
            <div class="col-md-6 p-1">
              <mat-checkbox class="example-margin" name="InquirySelfAssigned" *ngIf="showSelfEnquiry"
                id="InquirySelfAssigned" #refInquirySelfAssigned="ngModel"
                [(ngModel)]="inquiryModel.InquirySelfAssigned">
                Inquiry Self Assigned
              </mat-checkbox>
            </div>
            <div class="col-md-6 p-1" *ngIf="inquiryModel.InquirySelfAssigned">
              <span class="required-lable"> Branch </span>
              <select name="BranchId" id="BranchId" #refBranchId="ngModel" [ngClass]="{
                  'is-invalid': f.submitted && refBranchId.invalid,
                  'alert-warning':
                    refBranchId.invalid &&
                    (refBranchId.dirty ||
                      refBranchId.touched ||
                      refBranchId.untouched)
                }" [(ngModel)]="inquiryModel.BranchId" class="form-control input-text-css" required>
                <option value="">Select Branch</option>
                <option *ngFor="let branch of employeeBranchDropdown" [value]="branch.BranchId">
                  {{ branch.Branch_Name }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" (click)="OnClose()" class="btn font-size-12 button-btn" data-dismiss="modal">
            Cancel
          </button>
          <button type="button" (click)="onSaveInquiry()" class="btn font-size-12 button-btn" [class.spinner]="loading"
            [disabled]="!f.form.valid">
            Save
          </button>
        </div>
      </div>
    </div>
  </form>
</div>

<table id="quickLoan_Dashboard_export" class="table table-bordered bg-white"
  style="font-family: 'Times New Roman', Times, serif; display: none">
  <tr>
    <th style="background: #4dc3a3 !important; border: 1px solid white">#</th>
    <th style="background: #4dc3a3 !important; border: 1px solid white">
      Application
    </th>
    <th style="background: #4dc3a3 !important; border: 1px solid white">
      Customer
    </th>
    <th style="background: #4dc3a3 !important; border: 1px solid white">
      Product Name
    </th>
    <th style="background: #4dc3a3 !important; border: 1px solid white">
      Loan Amount
    </th>
    <th style="background: #4dc3a3 !important; border: 1px solid white">
      Branch Name
    </th>
    <th style="background: #4dc3a3 !important; border: 1px solid white">
      Employee
    </th>

    <th style="background: #4dc3a3 !important; border: 1px solid white">
      Source Type
    </th>

    <th style="background: #4dc3a3 !important; border: 1px solid white">
      Source Name
    </th>

    <th style="background: #4dc3a3 !important; border: 1px solid white">
      Assign On
    </th>
    <th style="background: #4dc3a3 !important; border: 1px solid white">
      Status
    </th>
    <th style="background: #4dc3a3 !important; border: 1px solid white">
      TAT(Hr)
    </th>
  </tr>
  <tr *ngFor="let x of JsonData; let i = index">
    <td>{{ i + 1 }}</td>
    <td>{{ x.Application_No }}</td>
    <td>{{ x.Customer }}</td>
    <td>{{ x.Product_Name }}</td>
    <td>{{ x.Application_LoanAmount }}</td>
    <td>{{ x.Branch_Name }}</td>
    <td>{{ x.EmpName }}</td>
    <td>{{ x.SourceType }}</td>
    <td>{{ x.SourceName }}</td>
    <td>{{ x.AssignOn }}</td>
    <td>{{ x.AP_ProcessStatus }}</td>
    <td>{{ x.TAT_Hr }}</td>
  </tr>
</table>

<table id="quickLoan_export_byTeam" class="table table-bordered bg-white"
  style="font-family: 'Times New Roman', Times, serif; display: none">
  <tr>
    <th style="background: #4dc3a3 !important; border: 1px solid white">#</th>
    <th style="background: #4dc3a3 !important; border: 1px solid white">
      Application No
    </th>
    <th style="background: #4dc3a3 !important; border: 1px solid white">
      Customer
    </th>
    <th style="background: #4dc3a3 !important; border: 1px solid white">
      Product Name
    </th>
    <th style="background: #4dc3a3 !important; border: 1px solid white">
      Application Loan Amount
    </th>
    <th style="background: #4dc3a3 !important; border: 1px solid white">
      Branch Name
    </th>
    <th style="background: #4dc3a3 !important; border: 1px solid white">
      Process Name
    </th>

    <th style="background: #4dc3a3 !important; border: 1px solid white">
      Source Type
    </th>

    <th style="background: #4dc3a3 !important; border: 1px solid white">
      Source Name
    </th>

    <th style="background: #4dc3a3 !important; border: 1px solid white">
      Assign On
    </th>
    <th style="background: #4dc3a3 !important; border: 1px solid white">
      Status
    </th>
    <th style="background: #4dc3a3 !important; border: 1px solid white">
      TAT(Hr)
    </th>
  </tr>
  <tr *ngFor="let x of JsonDataTeam; let i = index">
    <td>{{ i + 1 }}</td>
    <td>{{ x.Application_No }}</td>
    <td>{{ x.Customer }}</td>
    <td>{{ x.Product_Name }}</td>
    <td>{{ x.Application_LoanAmount }}</td>
    <td>{{ x.Branch_Name }}</td>
    <td>{{ x.Process_Name }}</td>
    <td>{{ x.SourceType }}</td>
    <td>{{ x.SourceName }}</td>

    <td>{{ x.AssignOn }}</td>
    <td>{{ x.AP_ProcessStatus }}</td>
    <td>{{ x.TAT_Hr }}</td>
  </tr>
</table>